import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import InvoiceSimulationDTO from "features/contracts/dtos/InvoiceSimulationDTO";
import InfoItem from "features/shared/components/infoItem/InfoItem";
import { formatDate, formatPrice } from "features/shared/helpers/Formatters";
import { useTranslation } from "react-i18next";

interface Props {
  invoiceSimulation: InvoiceSimulationDTO;
}

const InvoiceSimulationDetailRecapitulation = (props: Props) => {
  // translations
  const tLabels = useTranslation("invoiceSimulation\\invoiceSimulation").t;

  const getTotalAmountTitle = (totalAmount: number): string =>
    totalAmount < 0 ? tLabels("invoiceSimulationDetailRecapitulation.overpayment") : tLabels("invoiceSimulationDetailRecapitulation.arrears");
  
  // render
  return (
    <PageCard title={tLabels("invoiceSimulationDetailRecapitulation.cardTitle")}>
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("invoiceSimulationDetailRecapitulation.calculationDate")}
            value={formatDate(props.invoiceSimulation.calculationDate!)}
            icon="calendar-alt"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("invoiceSimulationDetailRecapitulation.periodFrom")}
            value={formatDate(props.invoiceSimulation.periodFrom!)}
            icon="hourglass-start"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("invoiceSimulationDetailRecapitulation.periodTo")}
            value={formatDate(props.invoiceSimulation.periodTo!)}
            icon="hourglass-end"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("invoiceSimulationDetailRecapitulation.taxableAmount")}
            value={formatPrice(
              props.invoiceSimulation.taxableAmount!,
              props.invoiceSimulation.currency!
            )}
            icon="money-bill-alt"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("invoiceSimulationDetailRecapitulation.taxAmount")}
            value={formatPrice(
              props.invoiceSimulation.taxAmount!,
              props.invoiceSimulation.currency!
            )}
            icon="money-bill-alt"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("invoiceSimulationDetailRecapitulation.taxIncusiveAmount")}
            value={formatPrice(
              props.invoiceSimulation.taxIncusiveAmount!,
              props.invoiceSimulation.currency!
            )}
            icon="money-bill-alt"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={tLabels("invoiceSimulationDetailRecapitulation.advance")}
            value={formatPrice(
              props.invoiceSimulation.advance!,
              props.invoiceSimulation.currency!
            )}
            icon="donate"
          />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-2 pb-2 pb-sm-3">
          <InfoItem
            title={getTotalAmountTitle(props.invoiceSimulation.totalAmount!)}
            value={formatPrice(
              props.invoiceSimulation.totalAmount!,
              props.invoiceSimulation.currency!
            )}
            icon="money-bill-alt"
          />
        </div>
      </div>
    </PageCard>
  );
};

export default InvoiceSimulationDetailRecapitulation;
